import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import QuickviewButton from './ProductCardQuickviewButton';
import SaveButton from './ProductCardSaveButton';
import style from './productCard.module.scss';

function ProductCardButtons({
  isSaved = false,
  onQuickViewClick = () => {},
  onSaveClick = () => {},
  showQuickView = true,
}) {
  return (
    <>
      <SaveButton onClick={onSaveClick} saved={isSaved} />
      {/* Ensure the quickview button is always accessible to screen readers regardless of
      visibility to other users */}
      <div className={classNames(style.buttons, { 'screen-reader-text': !showQuickView })} data-aui="product-card-buttons" data-testid="catalog-product-card-quickview-button">
        <QuickviewButton onClick={onQuickViewClick} />
      </div>

    </>
  );
}

ProductCardButtons.propTypes = {
  isSaved: PropTypes.bool,
  onQuickViewClick: PropTypes.func,
  onSaveClick: PropTypes.func,
  showQuickView: PropTypes.bool,
};

export default ProductCardButtons;
